import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	Input,
	InputGroup,
	InputGroupAddon,
	Label,
	FormGroup,
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Col,
	Row,
	Container,
	Card,
	CardHeader,
	CardBody,
	Collapse,
} from 'reactstrap';

import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';
import { formataData } from '../../BaseFunctions';

import { AlertasContext } from '../../Providers/Alertas';
import { BlockUiContext } from '../../Providers/BlockUi';

import './ImpressoesDetalhes.scss';
import ErroImpressaoGuiasEmitidas from './ErroImpressaoGuiasEmitidas';
import LinhaCopiavel from '../Emitidas/LinhaCopiavel';

const isSimulacao = localStorage.getItem('isSimulacao') === 'true';

class ImpressoesDetalhes extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			idGuiaAtual: 0,
			accordion: '0',
		};

		this.modalErroImprimir = React.createRef();
	}

	openModal = () => {
		this.setState({ isOpen: true, idGuiaAtual: 0 });
		setImmediate(() => this.setState({ accordion: this.props.value.guias[0].numControle }));
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	toggleCard = () => {
		const novaGuia = (this.state.idGuiaAtual + 1) % 2;
		this.setState({ idGuiaAtual: novaGuia, accordion: this.props.value.guias[novaGuia].numControle });
	};
	

	currencyFormat = num =>
		new Intl.NumberFormat('pt-BR', {
			style: 'currency',
			currency: 'BRL',
		}).format(num);

	baixarPdf = (id = null) => {
		this.onLoading(true);		
		const selected = [this.props.value.id];

		HttpUtil.eco_POST_CONFIG(`${Config.urls.API_URL_BASE}Documento/ImprimirAsync`, selected, {
			responseType: 'blob',
			headers: { Authorization: `bearer ${localStorage.getItem('AccessToken')}` },
		})
			.then(response => {
				const file = new Blob([response.data], { type: 'application/pdf' });
				this.onLoading(false);
				const fileURL = URL.createObjectURL(file);
				window.open(fileURL);
				this.closeModal();
			})
			.catch((error) => {
				this.onLoading(false);
				this.showErrorMessage('Não foi possível imprimir suas guias.');
			});
	};

	render() {
		const { value } = this.props;
		return (
			this.state.isOpen && (
				<Modal
					size="lg"
					id="modal-impressoes-detalhes"
					centered={true}
					isOpen={this.state.isOpen}
					onClosed={this.props.onClosed}
					backdrop="static">
					<ErroImpressaoGuiasEmitidas ref={this.modalErroImprimir} />
					<AlertasContext.Consumer>
						{alertas => {
							this.showInfoMessage = alertas.info;
							this.showSuccessMessage = alertas.success;
							this.showWarningMessage = alertas.warning;
							this.showErrorMessage = alertas.error;
						}}
					</AlertasContext.Consumer>
					<BlockUiContext.Consumer>
						{blockUi => {
							this.onLoading = blockUi.handleLoading;
						}}
					</BlockUiContext.Consumer>
					<ModalHeader className="outstanding">
						<Container>
							<Row className="justify-content-between">
								<Col xs="auto" className="order-first">
									Detalhes da Guia
								</Col>
								{value.status !== 'Arquivada' ? (
									<Col xs="auto" className="order-last">
										<Button
											color="link"
											onClick={() => this.baixarPdf()}
											disabled={isSimulacao}>
											<i className="fas fa-download" /> Baixar em PDF
										</Button>
									</Col>
								) : (
									<Col />
								)}
							</Row>
						</Container>
					</ModalHeader>
					<ModalBody>
						{value.guias.map(guia => (
							<Card
								key={guia.sequencial}
								className={`border-secondary ${
									this.state.accordion === guia.numControle ? 'aberto' : 'fechado'
								}`}>
								<CardHeader
									onClick={() => value.guias.length > 1 && this.toggleCard()}
									id={`${value.guias.length === 1 && 'unique'}`}>
									<FormGroup row className="justify-content-between">
										<Col xs="auto">
											<Label for={`sequencialGuia_${guia.sequencial}`}>Sequencial da Guia</Label>
											<Input
												id={`sequencialGuia_${guia.sequencial}`}
												plaintext
												readOnly
												value={guia.sequencial}
											/>
										</Col>
										<Col xs="auto">
											<Label for={`numControle_${guia.sequencial}`}>Número de Controle</Label>
											<Input
												id={`numControle_${guia.sequencial}`}
												plaintext
												readOnly
												value={guia.numControle}
											/>
										</Col>
										<Col xs="auto">
											<Label for={`uf_${guia.sequencial}`}>UF Favorecida</Label>
											<Input id={`uf_${guia.sequencial}`} plaintext readOnly value={guia.uf} />
										</Col>
										{value.guias.length > 1 && (
											<Col xs="auto">
												{this.state.accordion === guia.numControle ? (
													<Button color="link" size="sm">
														<i className="fas fa-chevron-up" />
													</Button>
												) : (
													<Button color="link" size="sm">
														<i className="fas fa-chevron-down" />
													</Button>
												)}
											</Col>
										)}
									</FormGroup>
								</CardHeader>
								<Collapse isOpen={this.state.accordion === guia.numControle}>
									<CardBody>
										<Row className="datas-valores">
											<Col xs="4">
												<Container fluid className="outstanding">
													<FormGroup row>
														<Col className="text-center">
															<Label for={`dtVenciamento_${guia.sequencial}`}>
																Data de vencimento
															</Label>
															<Input
																id={`dtVenciamento_${guia.sequencial}`}
																plaintext
																readOnly
																value={formataData(guia.dtVencimento)}
															/>
														</Col>
														<Col className="text-center">
															<Label for={`dtPagamento_${guia.sequencial}`}>
																Data de pagamento
															</Label>
															<Input
																id={`dtPagamento_${guia.sequencial}`}
																plaintext
																readOnly
																value={formataData(guia.dtPagamento)}
															/>
														</Col>
													</FormGroup>
												</Container>
											</Col>
											<Col xs="8">
												<Container fluid className="outstanding">
													<FormGroup row className="h-100">
														<Col className="text-center">
															<Label for={`vlPrincipal_${guia.sequencial}`}>
																Valor principal
															</Label>
															<Input
																id={`vlPrincipal_${guia.sequencial}`}
																plaintext
																readOnly
																value={this.currencyFormat(guia.vlPrincipal)}
															/>
														</Col>
														<Col className="text-center">
															<Label for={`vlJuros_${guia.sequencial}`}>Juros</Label>
															<Input
																id={`vlJuros_${guia.sequencial}`}
																plaintext
																readOnly
																value={this.currencyFormat(guia.vlJuros)}
															/>
														</Col>
														<Col className="text-center">
															<Label for={`vlMulta_${guia.sequencial}`}>Multa</Label>
															<Input
																id={`vlMulta_${guia.sequencial}`}
																plaintext
																readOnly
																value={this.currencyFormat(guia.vlMulta)}
															/>
														</Col>
														<Col className="text-center">
															<Label for={`vlAtualizacao_${guia.sequencial}`}>Atualização</Label>
															<Input
																id={`vlAtualizacao_${guia.sequencial}`}
																plaintext
																readOnly
																value={this.currencyFormat(guia.vlAtualizacao)}
															/>
														</Col>
														<Col className="order-last h-100 text-center">
															<Label for={`vlTotal_${guia.sequencial}`}>
																Valor total
															</Label>
															<Input
																id={`vlTotal_${guia.sequencial}`}
																plaintext
																readOnly
																value={this.currencyFormat(guia.vlTotal)}
															/>
														</Col>
													</FormGroup>
												</Container>
											</Col>
										</Row>
										<LinhaCopiavel titulo="Representação Numérica" valor={guia.representacao} mostrarSucesso={this.showSuccessMessage} />
										<LinhaCopiavel titulo="Código de Barras" valor={guia.codBarras} mostrarSucesso={this.showSuccessMessage} />
										<LinhaCopiavel titulo="Código PIX" valor={guia.codigoPix} mostrarSucesso={this.showSuccessMessage} />
										{guia.infoComplementares && <FormGroup row>
											<Col>
												<Label for={`strInfoComplementar_${guia.sequencial}`}>
													Informações complementares
												</Label>
											</Col>
											<Col xs="9">
												<Input
													id={`strInfoComplementar_${guia.sequencial}`}
													plaintext
													readOnly
													value={guia.infoComplementares}
												/>
											</Col>
										</FormGroup>}

										{guia.isGuiaFCP && (
											<FormGroup row>
												<Col xs="auto">
													<Label>*Obs:</Label>
												</Col>

												<Col xs="10">
													<strong>Há guia complementar para pagamento. Caso não esteja emitida, verificar se está em Pendentes necessitando de detalhamento.</strong>
												</Col>
											</FormGroup>
										)}									

									</CardBody>
								</Collapse>
							</Card>
						))}
					</ModalBody>
					<ModalFooter>
						<Container>
							<Row className="justify-content-end">
								<Col xs="auto">
									<Button color="info" onClick={() => this.closeModal()}>
										Fechar
									</Button>
								</Col>
							</Row>
						</Container>
					</ModalFooter>
				</Modal>
			)
		);
	}
}

ImpressoesDetalhes.propTypes = {
	value: PropTypes.object,
	onClosed: PropTypes.func.isRequired,
};

export default ImpressoesDetalhes;
